// Kratos protocol vocabulary the ID portal branches on (Kratos v26.2.0).

// `error.id` of the special-cased Kratos responses. Kratos identifies each case by id; the HTTP
// status alone cannot tell a step-up (403) from a CSRF failure (403).
export enum KratosErrorID {
    BrowserLocationChangeRequired = 'browser_location_change_required',
    SessionRefreshRequired        = 'session_refresh_required',
    SessionAal2Required           = 'session_aal2_required',
    SelfServiceFlowExpired        = 'self_service_flow_expired',
    SecurityCsrfViolation         = 'security_csrf_violation',
    SessionAlreadyAvailable       = 'session_already_available',
}

// `continue_with[].action` of a successful JSON submission.
export enum KratosContinueWithAction {
    RedirectBrowserTo = 'redirect_browser_to',
}

// The self-service flows the ID portal drives.
export enum KratosFlowType {
    Login    = 'login',
    Settings = 'settings',
    Recovery = 'recovery',
}

export enum KratosAal {
    Aal1 = 'aal1',
    Aal2 = 'aal2',
}

// `node.type`
export enum KratosNodeType {
    Input  = 'input',
    Text   = 'text',
    Image  = 'img',
    Anchor = 'a',
    Script = 'script',
}

// `node.attributes.type` for input nodes.
export enum KratosInputType {
    Hidden   = 'hidden',
    Submit   = 'submit',
    Button   = 'button',
    Password = 'password',
    Email    = 'email',
    Text     = 'text',
}

// `node.group` — the self-service method a node belongs to. `default` nodes (CSRF token, login
// identifier) belong to every submission.
export enum KratosNodeGroup {
    Default  = 'default',
    Password = 'password',
    Totp     = 'totp',
    Passkey  = 'passkey',
    WebAuthn = 'webauthn',
    Profile  = 'profile',
    Code     = 'code',
}

// `message.type`
export enum KratosMessageType {
    Info    = 'info',
    Success = 'success',
    Error   = 'error',
}

// `authentication_methods[].method` values that are a first factor.
export enum KratosAuthMethod {
    Password     = 'password',
    Passkey      = 'passkey',
    Totp         = 'totp',
    CodeRecovery = 'code_recovery',
}

// The outcome of `classifyKratosResponse()` — the single vocabulary every view branches on.
export enum KratosOutcome {
    // 2xx — a flow, session, logout or success envelope.
    Ok                            = 'ok',
    // 400 with a flow — Kratos re-served the flow with its messages (wrong password, wrong code).
    Validation                    = 'validation',
    // 422 — continue with a full browser navigation to `redirect_browser_to`.
    BrowserLocationChangeRequired = 'browser_location_change_required',
    // 403 — the privileged session (15 min) is too old; re-authenticate and come back.
    SessionRefreshRequired        = 'session_refresh_required',
    // 403 — a TOTP account without its code or passkey step (auth-api's settings gate).
    SessionAal2Required           = 'session_aal2_required',
    // 410 / 403 CSRF — the flow is no longer usable; restart it.
    FlowExpired                   = 'flow_expired',
    // 400 — a login flow was asked for while a session already exists.
    SessionAlreadyAvailable       = 'session_already_available',
    // 429 — the login lockout gate.
    TooManyAttempts               = 'too_many_attempts',
    // 401 — no Kratos session.
    NoSession                     = 'no_session',
    // Anything else, transport failures included.
    Error                         = 'error',
}
